<template>
    <div class="routing-rules">
        <div class="routing-rules__header">
            <h1>Modify Global Merchant Routing Rules</h1>
            <Button :disabled="!contents.rules.length" buttonName="Save Changes" :onClick="handleSave" classes="primary"  />
        </div>
        <div v-if="state.error.length" class="error">{{ state.error }}</div>
        <div class="routing-rules__table">
            <div class="routing-rules__table__header" >    
                <p :style="{ width: '10%'}">PRIORITY</p>
                <p :style="{ width: '30%'}">BANK</p>
                <p :style="{ width: '15%'}">PREFIX</p>
                <p :style="{ width: '15%'}">PREEXISTING </p>
                <p :style="{ width: '30%'}">INCOMING MERCHANTS</p>
            </div>
            <div class="routing-rules__table__body">
               <RoutineRule 
                 v-for="rule in contents.rules" 
                 :key="rule.id" 
                 :priority="rule.priority" 
                 :bank="rule.bank" 
                 :prefix="rule.prefix" 
                 :preExisting="rule.preExisting" 
                 :incomingMin="rule.incomingMin" 
                 :incomingMax="rule.incomingMax" 
                 :id="rule.id" 
                 :showDelete="true"
                 :handleRuleDelete="handleRuleDelete"
                 :onRuleChange="onRuleChangeOld"
                 :bankCode="rule.bankCode"
                 />
                <RoutineRule 
                 :priority="state.newRule.priority" 
                 :bank="state.newRule.bank" 
                 :prefix="state.newRule.bank_prefix + '******'" 
                 :preExisting="state.newRule.percent_of_merchants" 
                 :incomingMin="state.newRule.minimum_incoming" 
                 :incomingMax="state.newRule.maximum_incoming" 
                 :showDelete="false"
                 :handleRuleDelete="handleAddRule"
                 :onRuleChange="onRuleChangeNew"
                 :reset="state.reset"
                 :handleResetToggle="handleResetToggle"
                 />
            </div>
        </div>
    </div>
</template>
<script>
import { reactive, onBeforeMount, computed, watch } from '@vue/composition-api'
import { v4 as uuidv4 } from 'uuid';
import Button from "@/components/button.vue"
import RoutineRule from "@/components/routingrule.vue"
import { deleteFromArrayOfObject, addToArray, modifyArrayById } from "@/lib/arrayManipulation"
export default {
    components: {
        Button,
        RoutineRule
    },
    setup(props, { root }) {
        const store = root.$store;
        const contents = computed(() => store.getters.getRoutingRules);
        const rawContents = computed(() => store.getters.getRawRoutingRules);
        const bankList = computed(() => store.getters.getBankList);
        const state = reactive({
            newRule: {
                bank_code: "060001",
                percent_of_merchants: '',
                priority: null,
                minimum_incoming: null,
                maximum_incoming: null,
                bank_prefix: '',
                id: uuidv4()
            },
            error: '',
            reset: false,
        })
        onBeforeMount(() => {
            store.dispatch('getRoutingRules')
        })
        const handleRuleDelete = (id) => {
            const deletedArray = deleteFromArrayOfObject({
                array: rawContents.value.rules,
                key: 'id',
                value: id
            });
            store.commit('setRoutingRules', {
                loading: false,
                rules: deletedArray
            })
        }
        const handleAddRule = () => {
            const newRules = addToArray({ array: rawContents.value.rules, obj: state.newRule })
             store.commit('setRoutingRules', {
                loading: false,
                rules: newRules
            })
            state.newRule = {
                bank_code: "060001",
                percent_of_merchants: '',
                priority: null,
                minimum_incoming: null,
                maximum_incoming: null,
                bank_prefix: '',
                id: uuidv4()
            }
            state.reset = true
        }
        const onRuleChangeNew = ({ field, value }) => {
           state.newRule[field] = value;
        }
        const onRuleChangeOld = (data) => {
            const modifieldArray = modifyArrayById({
                array: rawContents.value.rules,
                ...data,
                id: data.id
            })
            store.commit('setRoutingRules', {
                loading: false,
                rules: modifieldArray
            })
        }
        
        const handleSave = () => {
            // validate here
            const rules = rawContents.value.rules;
            let totalPercent = 0;
            let isMinimumreaterThanMaximum = false;
            rules.forEach(({ percent_of_merchants, minimum_incoming , maximum_incoming}) => {
                totalPercent += Number(percent_of_merchants)
                // 
                if(Number(minimum_incoming) > Number(maximum_incoming) && maximum_incoming > 0 ) {
                   isMinimumreaterThanMaximum = true;
                }
            })
            if(totalPercent !== 100) {
                state.error = 'Total percent of pre existing must equal 100.'
                return;
            }
            if(isMinimumreaterThanMaximum) {
                state.error = 'Minimum merchant cannot be greater than maximum merchant.'
                return;
            }
            state.error = ''
            store.dispatch('saveRoutingRules', rawContents.value.rules)
        }
        const handleResetToggle = () => state.reset = !state.reset
        return {
            contents,
            handleRuleDelete,
            handleAddRule,
            state,
            onRuleChangeNew,
            onRuleChangeOld,
            handleSave,
            handleResetToggle
        }
    }
}
</script>
<style lang="scss">
.routing-rules {
    width: 100%;

    &__header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 60px 30px 30px;
        h1 {
            font-style: normal;
            font-weight: normal;
            font-size: 18px;
            line-height: 14px;
        }
    }
    &__table {
        padding: 30px;
        margin-bottom: 100px;
        &__header {
            width: 100%;
            display: flex;
            align-items: center; 
            padding: 14px;
            background: #EBF0F4;
            border-radius: 3px;
            p {
                /*font-family: 'lato-regular';*/
                font-style: normal;
                font-weight: 500;
                font-size: 12px;
                line-height: 14px;
                letter-spacing: 0.1em;
                text-transform: uppercase;
                color: #655D79;
                text-align: start;
            }
        }
        &__body {
            width: 100%;
            padding: 0 14px;
        }
    }
    .percentage {
        input {
            text-align: start;
        }
    }
    .error {
        padding: 0 30px;
        color: red;
    }
}
</style>